module.exports = __webpack_public_path__ + "static/media/ecommerce.173a359d.png";